import React from 'react'
import PropTypes from "prop-types";
import Workspace from "components/Workspace";
import PapersGeneratorXmpUzpPresidentPaperContent from "components/complex/papersGenerator/customPopups/xmpUzpPresidentPaper/PapersGeneratorXmpUzpPresidentPaperContent";

function XmlUzpPresidentPaper(
    {
        demandId
    }) {
    return (
        <Workspace>
            <PapersGeneratorXmpUzpPresidentPaperContent demandId={demandId}/>
        </Workspace>
    )
}

XmlUzpPresidentPaper.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default XmlUzpPresidentPaper;
